/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/components/ingresocausa/partes-causa.component';
import * as i4 from './repre-causa-popup.component.ngfactory';
import * as i5 from '../../../../../src/app/components/ingresocausa/repre-causa-popup.component';
import * as i6 from '../../../../../src/app/services/usuario.service';
import * as i7 from '../../../../../src/app/services/expediente.service';
import * as i8 from '../../../../../src/app/services/common.service';
import * as i9 from '../../common/dialog/mensaje.component.ngfactory';
import * as i10 from '../../../../../src/app/common/dialog/mensaje.component';
var styles_PartesCausaComponent = [];
export var RenderType_PartesCausaComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_PartesCausaComponent, data: {} });
function View_PartesCausaComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class',
                'horizontal-collapse'], ['style', 'margin-top:20px;']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'well']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            ', '\n            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-secondary']], [[8, 'hidden', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickOK() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Continuar'])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.MsgPartesConexo;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.verAceptar;
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_PartesCausaComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descr;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_PartesCausaComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descr;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_PartesCausaComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.codigo;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.codigo;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.codigo;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_PartesCausaComponent_7(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descr;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_PartesCausaComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class',
                'col-sm-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 21, 'div', [['class', 'form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'select colorlbx']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Género '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'select', [['class', 'form-control bginputs']], null, [[null, 'focus'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('focus' === en)) {
                var pd_0 = (_co.hideErrorMsg() !== false);
                ad = (pd_0 && ad);
            }
            if (('change' === en)) {
                var pd_1 = (_co.onChangeSelectGenero($event.target.value) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        (_l()(), i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_7)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = '0';
        _ck(_v, 14, 0, currVal_0);
        var currVal_1 = '0';
        _ck(_v, 15, 0, currVal_1);
        var currVal_2 = _co.generoList;
        _ck(_v, 19, 0, currVal_2);
    }, null);
}
function View_PartesCausaComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 50, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class', 'col-sm-4']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 21, 'div', [['class', 'form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 18, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'select colorlbx']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Documento'])), (_l()(),
            i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 9, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'ngModelChange'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 14).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onChangeSelect($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = ((_co.parte.tdo_cod = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_5)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'col-sm-4']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 15, 'div', [['class', 'form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['N° de Documento'])), (_l()(),
            i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control input-sm bginputs'], ['name',
                'documento'], ['type', 'number']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'input'], [null,
                'keypress'], [null, 'ngModelChange'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 38)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 38).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 38)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 38)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (i0.ɵnov(_v, 39).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (i0.ɵnov(_v, 39).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (i0.ɵnov(_v, 39).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('input' === en)) {
                var pd_7 = (_co.verificarMaxLength($event) !== false);
                ad = (pd_7 && ad);
            }
            if (('keypress' === en)) {
                var pd_8 = (_co._keyPress($event) !== false);
                ad = (pd_8 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_9 = ((_co.parte.numero = $event) !== false);
                ad = (pd_9 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i1.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i1.DefaultValueAccessor, i1.ɵbc]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_6)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.parte.tdo_cod;
        _ck(_v, 16, 0, currVal_7);
        var currVal_8 = _co.tdocList;
        _ck(_v, 21, 0, currVal_8);
        var currVal_16 = 'documento';
        var currVal_17 = _co.parte.numero;
        _ck(_v, 41, 0, currVal_16, currVal_17);
        var currVal_18 = _co.permisoUsaRenaper;
        _ck(_v, 49, 0, currVal_18);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 18).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 18).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 18).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 18).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 18).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 18).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 18).ngClassPending;
        _ck(_v, 13, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_9 = i0.ɵnov(_v, 43).ngClassUntouched;
        var currVal_10 = i0.ɵnov(_v, 43).ngClassTouched;
        var currVal_11 = i0.ɵnov(_v, 43).ngClassPristine;
        var currVal_12 = i0.ɵnov(_v, 43).ngClassDirty;
        var currVal_13 = i0.ɵnov(_v, 43).ngClassValid;
        var currVal_14 = i0.ɵnov(_v, 43).ngClassInvalid;
        var currVal_15 = i0.ɵnov(_v, 43).ngClassPending;
        _ck(_v, 37, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
    });
}
function View_PartesCausaComponent_9(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.codigo;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.codigo;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.codigo;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_PartesCausaComponent_8(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 47, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class', 'col-sm-6 ajuste-mb']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 21, 'div', [['class', 'form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 18, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'select colorlbx']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Documento'])), (_l()(),
            i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 9, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'ngModelChange'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 14).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onChangeSelect($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = ((_co.parte.tdo_cod = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_9)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'col-sm-6 ajuste-mb']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['N° de CUIT'])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control input-sm bginputs'], ['name', 'documento'],
            ['type', 'number']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 38)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 38).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 38)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 38)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (i0.ɵnov(_v, 39).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (i0.ɵnov(_v, 39).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (i0.ɵnov(_v, 39).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_co.parte.numero = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i1.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i1.DefaultValueAccessor, i1.ɵbc]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.parte.tdo_cod;
        _ck(_v, 16, 0, currVal_7);
        var currVal_8 = _co.tdocListJur;
        _ck(_v, 21, 0, currVal_8);
        var currVal_16 = 'documento';
        var currVal_17 = _co.parte.numero;
        _ck(_v, 41, 0, currVal_16, currVal_17);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 18).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 18).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 18).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 18).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 18).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 18).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 18).ngClassPending;
        _ck(_v, 13, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_9 = i0.ɵnov(_v, 43).ngClassUntouched;
        var currVal_10 = i0.ɵnov(_v, 43).ngClassTouched;
        var currVal_11 = i0.ɵnov(_v, 43).ngClassPristine;
        var currVal_12 = i0.ɵnov(_v, 43).ngClassDirty;
        var currVal_13 = i0.ɵnov(_v, 43).ngClassValid;
        var currVal_14 = i0.ɵnov(_v, 43).ngClassInvalid;
        var currVal_15 = i0.ɵnov(_v, 43).ngClassPending;
        _ck(_v, 37, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
    });
}
function View_PartesCausaComponent_10(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-xs-12 col-sm-8  isa_error msg-error']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-times-circle']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ErrorMsgB;
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_PartesCausaComponent_11(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 39, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'form-group alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'fg-line']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Nombre'])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['name', 'nombre'], ['type', 'text']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 12)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 12)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 12)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.parte.nombre = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'form-group alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Apellido'])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'], ['name', 'apellido'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.parte.apellido = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'nombre';
        var currVal_8 = !_co.isEnabledPer;
        var currVal_9 = _co.parte.nombre;
        _ck(_v, 14, 0, currVal_7, currVal_8, currVal_9);
        var currVal_17 = 'apellido';
        var currVal_18 = !_co.isEnabledPer;
        var currVal_19 = _co.parte.apellido;
        _ck(_v, 33, 0, currVal_17, currVal_18, currVal_19);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 16).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 16).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 16).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 16).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 16).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 16).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_10 = i0.ɵnov(_v, 35).ngClassUntouched;
        var currVal_11 = i0.ɵnov(_v, 35).ngClassTouched;
        var currVal_12 = i0.ɵnov(_v, 35).ngClassPristine;
        var currVal_13 = i0.ɵnov(_v, 35).ngClassDirty;
        var currVal_14 = i0.ɵnov(_v, 35).ngClassValid;
        var currVal_15 = i0.ɵnov(_v, 35).ngClassInvalid;
        var currVal_16 = i0.ɵnov(_v, 35).ngClassPending;
        _ck(_v, 30, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
    });
}
function View_PartesCausaComponent_12(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'form-group alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'fg-line']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Razón Social'])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['name', 'nombre'], ['type', 'text']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 12)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 12)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 12)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.parte.nombre = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'nombre';
        var currVal_8 = !_co.isEnabledPer;
        var currVal_9 = _co.parte.nombre;
        _ck(_v, 14, 0, currVal_7, currVal_8, currVal_9);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 16).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 16).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 16).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 16).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 16).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 16).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_PartesCausaComponent_13(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-7 col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [['class', 'ts-label reset-margin alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Modificar domicilio'])), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'col-xs-5 col-sm-6 padBottom2 reset-margin alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 10, 'label', [['class', 'switch']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['type', 'checkbox']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 13).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 13).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.isEnabledPerDom = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.CheckboxControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.CheckboxControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 0, 'span', [['class', 'slider round']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.isEnabledPerDom;
        _ck(_v, 15, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 17).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 17).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 17).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 17).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 17).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 17).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 17).ngClassPending;
        _ck(_v, 12, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_PartesCausaComponent_14(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-xs-12 col-sm-8  isa_error msg-error']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-times-circle']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ErrorMsg;
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_PartesCausaComponent_16(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class',
                'cursorHand']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.toggleDetails(_v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['aria-hidden', 'true'],
            ['class', 'fa fa-user tamañoIcono']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                ']))], null, null);
}
function View_PartesCausaComponent_17(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class',
                'cursorHand'], ['data-backdrop', 'static'], ['data-keyboard', 'false'], ['data-toggle',
                'modal']], [[1, 'data-target', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.addRepre(_v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['aria-hidden', 'true'],
            ['class', 'fa fa-plus-circle tamañoIcono']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('#repre-causa-popup-' + _co.instanceId);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_PartesCausaComponent_18(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'td', [['colspan', '100']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'child-table', [], null, [[null, 'onDelete']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onDelete' === en)) {
                var pd_0 = (_co.onDeleteRepre(_v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ChildTable_0, RenderType_ChildTable)), i0.ɵdid(49152, [[2, 4]], 0, i3.ChildTable, [], { details: [0, 'details'] }, { onDelete: 'onDelete' }), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        ']))], function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.representantes;
        _ck(_v, 5, 0, currVal_0);
    }, null);
}
function View_PartesCausaComponent_15(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 33, 'tr', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' ', ''])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' ', ''])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_16)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_17)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 6, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'cursorHand']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.deleteParte(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['aria-hidden', 'true'],
            ['class', 'fa fa-trash-o tamañoIcono']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_18)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_6 = (((_v.context.$implicit.representantes == null) ? null : _v.context.$implicit.representantes.length) > 0);
        _ck(_v, 19, 0, currVal_6);
        var currVal_7 = (_v.context.$implicit.numero != '');
        _ck(_v, 25, 0, currVal_7);
        var currVal_8 = _co.isDetailsOpen(_v.context.index);
        _ck(_v, 38, 0, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.vinculo;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.nombre;
        var currVal_2 = _v.context.$implicit.apellido;
        _ck(_v, 8, 0, currVal_1, currVal_2);
        var currVal_3 = _v.context.$implicit.tdo_cod;
        var currVal_4 = _v.context.$implicit.numero;
        _ck(_v, 11, 0, currVal_3, currVal_4);
        var currVal_5 = _v.context.$implicit.domicilio;
        _ck(_v, 14, 0, currVal_5);
    });
}
function View_PartesCausaComponent_19(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-xs-12 col-sm-8  isa_error msg-error']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-times-circle']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ErrorMsgR;
        _ck(_v, 5, 0, currVal_0);
    });
}
export function View_PartesCausaComponent_0(_l) {
    return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { reprePopup: 0 }), i0.ɵqud(671088640, 2, { childTable: 0 }),
        i0.ɵqud(402653184, 3, { msgPopup: 0 }), (_l()(), i0.ɵeld(0, null, null, 205, 'div', [['class', 'panel-body height-panel-nuevacausa']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [['class',
                'wizard-title']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Partes de la causa'])), (_l()(),
            i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_1)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 29, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 26, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 23, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'select colorlbx']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Vinculo '])), (_l()(),
            i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 14, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'change'],
            [null, 'ngModelChange'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 23).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 23).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onChangeSelectTvi($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = ((_co.tipoVinculo.id = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef,
            i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null),
        i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['Seleccionar...'])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_2)),
        i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 29, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 26, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 23, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'select colorlbx']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Persona'])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 14, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'ngModelChange'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 54).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 54).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onChangeSelectTipo($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = ((_co.parte.tip_id = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef,
            i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null),
        i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['Seleccionar...'])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_3)),
        i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_4)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_8)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_10)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-sm-4 col-sm-offset-4']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar ajuste-margen-top']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickBuscarPer() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Buscar'])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_11)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_12)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(),
            i0.ɵeld(0, null, null, 22, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-xs-7 col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'label', [['class', 'ts-label reset-margin alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Modificar nombre'])), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'col-xs-5 col-sm-6 padBottom2 reset-margin alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵeld(0, null, null, 10, 'label', [['class', 'switch']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n              '])), (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['type', 'checkbox']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 110).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 110).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.isEnabledPer = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.CheckboxControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.CheckboxControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n              '])), (_l()(), i0.ɵeld(0, null, null, 0, 'span', [['class', 'slider round']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(),
            i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n         '])),
        (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-sm-7']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Domicilio'])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['name', 'domicilio'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 133)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 133).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 133)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 133)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.parte.domicilio = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_13)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_14)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(),
            i0.ɵeld(0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-sm-4 col-sm-offset-4']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.onClickAgregar() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), i0.ɵted(null, ['Agregar'])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 37, 'div', [['class', 'card alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 34, 'div', [['class', 'table-responsive']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 31, 'table', [['class', 'table table-striped']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 22, 'thead', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 19, 'tr', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [['class', 'ctth']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['VINCULO'])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [['class', 'ctth']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['APELLIDO Y NOMBRE'])), (_l()(),
            i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [['class', 'ctth']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['DOCUMENTO'])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'th', [['class', 'ctth']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['DOMICILIO'])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'th', [['class', 'ctth']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'th', [['class', 'ctth']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'th', [['class', 'ctth']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 4, 'tbody', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_15)),
        i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PartesCausaComponent_19)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(),
            i0.ɵeld(0, null, null, 4, 'div', [['aria-labelledby', 'myLargeModalLabel'],
                ['class', 'modal fade bs-example-modal-lg'], ['role', 'dialog'], ['tabindex',
                    '-1']], [[8, 'id', 0]], null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'repre-causa-popup', [], null, [[null,
                'onComplete']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onComplete' === en)) {
                var pd_0 = (_co.onCompleteRepre($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i4.View_RepreCausaPopupComponent_0, i4.RenderType_RepreCausaPopupComponent)),
        i0.ɵdid(114688, [[1, 4]], 0, i5.RepreCausaPopupComponent, [i6.UsuarioService, i1.FormBuilder,
            i7.ExpedienteService, i8.CommonService], { tviListRepre: [0, 'tviListRepre'],
            tdocList: [1, 'tdocList'] }, { onComplete: 'onComplete' }), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'app-message', [], null, null, null, i9.View_Message_0, i9.RenderType_Message)), i0.ɵdid(49152, [[3, 4]], 0, i10.Message, [], { config: [0, 'config'] }, null),
        (_l()(), i0.ɵted(null, ['\n\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.visibleMsg;
        _ck(_v, 9, 0, currVal_0);
        var currVal_8 = _co.tipoVinculo.id;
        _ck(_v, 25, 0, currVal_8);
        var currVal_9 = '0';
        _ck(_v, 30, 0, currVal_9);
        var currVal_10 = '0';
        _ck(_v, 31, 0, currVal_10);
        var currVal_11 = _co.tviListParte;
        _ck(_v, 35, 0, currVal_11);
        var currVal_19 = _co.parte.tip_id;
        _ck(_v, 56, 0, currVal_19);
        var currVal_20 = '0';
        _ck(_v, 61, 0, currVal_20);
        var currVal_21 = '0';
        _ck(_v, 62, 0, currVal_21);
        var currVal_22 = _co.tipList;
        _ck(_v, 66, 0, currVal_22);
        var currVal_23 = _co.isFisica;
        _ck(_v, 74, 0, currVal_23);
        var currVal_24 = !_co.isFisica;
        _ck(_v, 77, 0, currVal_24);
        var currVal_25 = _co.ErrorMessageIsVisibleB;
        _ck(_v, 80, 0, currVal_25);
        var currVal_26 = _co.isFisica;
        _ck(_v, 92, 0, currVal_26);
        var currVal_27 = !_co.isFisica;
        _ck(_v, 95, 0, currVal_27);
        var currVal_35 = _co.isEnabledPer;
        _ck(_v, 112, 0, currVal_35);
        var currVal_43 = 'domicilio';
        var currVal_44 = !_co.isEnabledPerDom;
        var currVal_45 = _co.parte.domicilio;
        _ck(_v, 135, 0, currVal_43, currVal_44, currVal_45);
        var currVal_46 = _co.permisoUsaRenaper;
        _ck(_v, 144, 0, currVal_46);
        var currVal_47 = _co.ErrorMessageIsVisible;
        _ck(_v, 147, 0, currVal_47);
        var currVal_48 = _co.partes;
        _ck(_v, 191, 0, currVal_48);
        var currVal_49 = _co.ErrorMessageIsVisibleR;
        _ck(_v, 198, 0, currVal_49);
        var currVal_51 = _co.tviListRepre;
        var currVal_52 = _co.tdocList;
        _ck(_v, 203, 0, currVal_51, currVal_52);
        var currVal_53 = _co.mensajeConfigSource;
        _ck(_v, 207, 0, currVal_53);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = i0.ɵnov(_v, 27).ngClassUntouched;
        var currVal_2 = i0.ɵnov(_v, 27).ngClassTouched;
        var currVal_3 = i0.ɵnov(_v, 27).ngClassPristine;
        var currVal_4 = i0.ɵnov(_v, 27).ngClassDirty;
        var currVal_5 = i0.ɵnov(_v, 27).ngClassValid;
        var currVal_6 = i0.ɵnov(_v, 27).ngClassInvalid;
        var currVal_7 = i0.ɵnov(_v, 27).ngClassPending;
        _ck(_v, 22, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_12 = i0.ɵnov(_v, 58).ngClassUntouched;
        var currVal_13 = i0.ɵnov(_v, 58).ngClassTouched;
        var currVal_14 = i0.ɵnov(_v, 58).ngClassPristine;
        var currVal_15 = i0.ɵnov(_v, 58).ngClassDirty;
        var currVal_16 = i0.ɵnov(_v, 58).ngClassValid;
        var currVal_17 = i0.ɵnov(_v, 58).ngClassInvalid;
        var currVal_18 = i0.ɵnov(_v, 58).ngClassPending;
        _ck(_v, 53, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_28 = i0.ɵnov(_v, 114).ngClassUntouched;
        var currVal_29 = i0.ɵnov(_v, 114).ngClassTouched;
        var currVal_30 = i0.ɵnov(_v, 114).ngClassPristine;
        var currVal_31 = i0.ɵnov(_v, 114).ngClassDirty;
        var currVal_32 = i0.ɵnov(_v, 114).ngClassValid;
        var currVal_33 = i0.ɵnov(_v, 114).ngClassInvalid;
        var currVal_34 = i0.ɵnov(_v, 114).ngClassPending;
        _ck(_v, 109, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_36 = i0.ɵnov(_v, 137).ngClassUntouched;
        var currVal_37 = i0.ɵnov(_v, 137).ngClassTouched;
        var currVal_38 = i0.ɵnov(_v, 137).ngClassPristine;
        var currVal_39 = i0.ɵnov(_v, 137).ngClassDirty;
        var currVal_40 = i0.ɵnov(_v, 137).ngClassValid;
        var currVal_41 = i0.ɵnov(_v, 137).ngClassInvalid;
        var currVal_42 = i0.ɵnov(_v, 137).ngClassPending;
        _ck(_v, 132, 0, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42);
        var currVal_50 = ('repre-causa-popup-' + _co.instanceId);
        _ck(_v, 200, 0, currVal_50);
    });
}
export function View_PartesCausaComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'partes-causa', [], null, null, null, View_PartesCausaComponent_0, RenderType_PartesCausaComponent)), i0.ɵdid(114688, null, 0, i3.PartesCausaComponent, [i6.UsuarioService, i8.CommonService, i7.ExpedienteService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var PartesCausaComponentNgFactory = i0.ɵccf('partes-causa', i3.PartesCausaComponent, View_PartesCausaComponent_Host_0, { tex_cod: 'tex_cod', conexo: 'conexo' }, { onComplete: 'onComplete' }, []);
var styles_ChildTable = ['table[_ngcontent-%COMP%]{width:100%}'];
export var RenderType_ChildTable = i0.ɵcrt({ encapsulation: 0, styles: styles_ChildTable,
    data: {} });
function View_ChildTable_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 18, 'tr', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'td', [['class', 'ctth-1']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [['class', 'ctth-1']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' ', ''])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'td', [['class', 'ctth-1']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ' ', ''])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 6, 'td', [['class', 'ctth-1']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'cursorHand']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.deleteRepre(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['aria-hidden', 'true'],
            ['class', 'fa fa-trash-o tamañoIcono']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.tipoVin.descr;
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.tdo_cod;
        var currVal_2 = _v.context.$implicit.numero;
        _ck(_v, 7, 0, currVal_1, currVal_2);
        var currVal_3 = _v.context.$implicit.nombre;
        var currVal_4 = _v.context.$implicit.apellido;
        _ck(_v, 10, 0, currVal_3, currVal_4);
    });
}
export function View_ChildTable_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 24, 'table', [['class', 'table']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(),
            i0.ɵeld(0, null, null, 15, 'thead', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 12, 'tr', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [['class', 'ctth-0']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Caracter'])), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [['class',
                'ctth-0']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Documento'])), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [['class', 'ctth-0']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Nombre y Apellido'])), (_l()(),
            i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵeld(0, null, null, 0, 'td', [['class', 'ctth-0']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n      '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'tbody', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_ChildTable_1)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.details;
        _ck(_v, 23, 0, currVal_0);
    }, null);
}
export function View_ChildTable_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'child-table', [], null, null, null, View_ChildTable_0, RenderType_ChildTable)),
        i0.ɵdid(49152, null, 0, i3.ChildTable, [], null, null)], null, null);
}
export var ChildTableNgFactory = i0.ɵccf('child-table', i3.ChildTable, View_ChildTable_Host_0, { details: 'details' }, { onDelete: 'onDelete' }, []);
//# sourceMappingURL=partes-causa.component.ngfactory.js.map